import React from 'react';
import { colors, Grid, Icon } from '@material-ui/core';
import { BookmarkBorder } from '@material-ui/icons';

import Description from 'components/typography/Description';

const EmptyRecipes = () => {
  return (
    <Grid container direction="column" spacing={1}>
      <Grid item>
        <Description>
          You have <b>no</b> bookmarked recipes
        </Description>
      </Grid>

      <Grid item>
        <Description>
          Inside of a recipe, click in the{' '}
          <Icon style={{ color: colors.red[400] }}>
            <BookmarkBorder></BookmarkBorder>
          </Icon>{' '}
          to <b>bookmark</b> the recipe
        </Description>
      </Grid>
    </Grid>
  );
};

export default EmptyRecipes;
